



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { DateTimeFormatOptions } from 'vue-i18n';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    name: 'c-agr-log-modal'
})
export default class CBudgetAgreementLogModal extends Vue{

    private showModal = false;

    private histArr: any [] = [];

    private histLst: any[] = [];

    private progress = 0;

    private async showEvent(id: number, agrObj?: any | null) {
        this.showModal = true;
        this.histArr = [];
        this.progress = 25;

        this.progress = 35;
        let response: any = null;
        try {
            response = await fetch(`/api-py/get-budget-event-agreement-log/${id}`);
            this.progress = 85;
            response = await response.json();
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-agreement-spf-log', (error as Error).toString());
        }
        if (response && agrObj) {
            response.push(agrObj);
        }
        await this.getLog(response);
        this.progress = 100;
    }

    private async getLog(response: any[]) {
        const userMap = new Map();
        for (const el of response) {
            const userObj: {name: string} = await this.getUserObj(el.userId, userMap);
            el.userName = userObj.name;
            el.dt = el.updateDate ? this.dateFormat(new Date(el.updateDate)) : null;
            el.status = setNameLang(this.$i18n.locale, {status: el.status, name_ru: el.name_ru, name_kk: el.name_kk, name_en: el.name_en});
        }
        this.histLst = response;
    }

    private async getUserObj(userId: string, userMap: Map<string, any>) {
        let userObj = await userMap.get(userId);
        if (!userObj) {
            const name = await this.getUserName(userId);
            userObj = { name: name };
            userMap.set(userId, userObj);
        }
        return userObj;
    }

    private async getUserName(userId: string) {
        const response: any = await fetch(`/api-py/get-realm-user/${encodeURI(userId)}`);
            if (response.status === 200) {
                const result = await response.json();
                if (!result) { return ''; }
                return (result.firstName ? `${result.firstName} `: '') + (result.lastName ? result.lastName: '');
            } else {
                makeToast(this, 'danger', 'Ошибка /api-py/get-realm-user', userId);
                return '';
            }
    }

    private dateFormat(date: Date): string {
        return new Intl.DateTimeFormat(this.$i18n.locale, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            change_log: this.getBudgetText('sum_calc_abp.change_log'), // Журнал изменений
            close: this.getBudgetText('button.close'), // Закрыть
        }
        return obj;
    }

}
